import type { SVGProps } from 'react';

const SvgSignalCellular4Bar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M2 22h20V2z" />
  </svg>
);
export default SvgSignalCellular4Bar;
